import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip, Icon } from '@burna/monster-design-system';
import axios from 'axios';
import ManageSettings from 'components/manage-settings';
import InputField from 'components/input-field';
import { APIName } from 'config';
import { copyToClipboard } from 'utils';
import styles from './index.module.scss';

function Manage() {
  const location = useLocation();
  const [{ url, error, fileUrlList = [] }, setData] = useState({});
  const [copied, setCopied] = useState(false);
  const copyTimeoutRef = useRef();

  useEffect(() => {
    axios
      .get(`/api/${APIName}${location.pathname}`)
      .then(({ data }) => {
        setData({ url: data.url, fileUrlList: data.fileUrlList });
      })
      .catch(error => {
        console.log(error);
        setData({ error: error?.response?.status || 500 });
      });
  }, [location]);

  const handleCopy = url => () => {
    setCopied(true);
    clearTimeout(copyTimeoutRef.current);
    copyTimeoutRef.current = setTimeout(() => setCopied(false), 3000);
    copyToClipboard(`${window.origin}${url}`.replace(/(?!^) (?!$)/g, '%20'));
  };

  const renderError = () => {
    if (!error) {
      return null;
    }
    if (error === 401) {
      return (
        <h1 className={styles.heading}>You don't have access to this page!</h1>
      );
    }
    if (error === 404) {
      return (
        <h1 className={styles.heading}>The requested file does not exist!</h1>
      );
    }
    return (
      <h1 className={styles.heading}>
        An unexpected error happened, try again!
      </h1>
    );
  };

  return (
    <section className={styles.container}>
      {renderError()}
      {url && (
        <div className={styles.content}>
          <h1 className={styles.heading}>
            Your public URL
            <span className={styles.iconWrapper} onClick={handleCopy(url)}>
              <Tooltip
                text="copied"
                visible={copied}
                positions={['right', 'top', 'bottom', 'left']}
                offset={{ top: 80 }}>
                <Icon className={styles.icon} type="copy" />
              </Tooltip>
            </span>
          </h1>
          <InputField text={`${window.origin}${url}`} />
          <h2 className={styles.heading}>File Settings</h2>
          <ManageSettings initialFileUrlList={fileUrlList} />
        </div>
      )}
    </section>
  );
}

export default Manage;
